<template>
  <NuxtLayout>
    <PoliciesTheTermsOfUse />
  </NuxtLayout>
</template>
<script setup lang="ts">
/**
 * Terms of Use
 * This page is responsible for rendering the terms of use.
 */

// Set the page meta data
definePageMeta({
  showNotificationBar: false,
  showFabModal: false,
})

// Set the page title
useHead({
  title: 'Terms of Use',
})
</script>
